import { checkInError } from './checkInError.routes';
import { examError } from './examError';
import { patientDataError } from './patientDataError';
import { paymentError, insuranceError } from './paymentError.route';
import { keycloackLoginError } from './collaboratorError.route';

const errorRoutes = [
  ...checkInError,
  ...examError,
  ...keycloackLoginError,
  ...patientDataError,
  ...paymentError,
  ...insuranceError,
];

export default errorRoutes;
